<template lang="pug">
  v-content
    v-container(fluid)
      v-flex
        h2(class="h1 d-flex justify-center mb-5" style="padding:30px 0 10px 20px;font-weight:bold") Pilih Jenis Izin Pekerjaan
        MenuListPermit 
          
        v-spacer
</template>

<script>

import { mapState } from "vuex";
import MenuListPermit from "../components/MenuListPermit.vue";
export default {
  name: "FormMenu",
  components: {
    MenuListPermit
  },
  data () {
    return {
      dialog: false,
      userPermitHolder: [],
      syncLocations:[],
    }
  },
  computed: {
    ...mapState(["API_URL", "locations",'permitHolder'])
  },
  mounted() {
    this.$store.dispatch("fetchLocations");
    // this.$store.dispatch("fetchPermitHolder").then(() => {
    //   this.userPermitHolder = this.permitHolder;
    // });
  }
};
</script>
